import { useMarkerContext } from 'features/pointClouds'
import { useObservationHandlers } from 'pages/pointClouds/components/observations/hooks/useObservationHandlers'
import { useObservations } from 'pages/pointClouds/components/observations/hooks/useObservations'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { ObservationContentArea } from './ObservationContentArea'
import { TooltipFooter } from './TooltipFooter'
import { TooltipHeader } from './TooltipHeader'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ObservationTooltipContent: React.FC = () => {
  const { activeTooltipId } = useMarkerContext()
  const { observations } = useObservations()
  const observation = activeTooltipId
    ? observations.find((obs) => obs.id === activeTooltipId)
    : null

  const { ignoreObservation, handleEditObservation, createTicket } =
    useObservationHandlers()

  const [displayedObservation, setDisplayedObservation] = useState(observation)

  useEffect(() => {
    if (observation) {
      setDisplayedObservation(observation)
    } else {
      const timer = setTimeout(() => {
        setDisplayedObservation(null)
      }, 300)

      return () => clearTimeout(timer)
    }
  }, [observation])

  if (!displayedObservation) {
    return null
  }

  return (
    <ContentWrapper>
      <TooltipHeader observation={displayedObservation} />
      <ObservationContentArea observation={displayedObservation} />
      <TooltipFooter
        observation={displayedObservation}
        onIgnore={ignoreObservation}
        onCreateTicket={createTicket}
        onEdit={handleEditObservation}
      />
    </ContentWrapper>
  )
}
